module.exports = __webpack_public_path__ + "static/media/bed-bunk.bf13071a.svg";